"use client";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
const ShelveSubscriptionAdsLoader = ({
    children,
    adsMediaData,
}: {
    children?: React.ReactNode;
    adsMediaData: any;
}) => {
    const { hasMouseMoved } = useMouseMovement();

    return hasMouseMoved ? (
        children
    ) : (
        <section>
            {adsMediaData.map((item: any, index: number) => (
                <img key={index} alt={item.dataId} />
            ))}
        </section>
    );
};

export default ShelveSubscriptionAdsLoader;